import { IconButton } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Fullscreen } from '@mui/icons-material'
import { useHistory } from 'react-router-dom'
import useSelectedPhoto from 'photo-module/photo/core/useSelectedPhoto'

const useStyles = makeStyles(() => ({
  fullscreenOverlay: {
    color: 'white',
    zIndex: 1000,
    '& svg': {
      height: '30px !important',
      width: '30px !important',
    },
  },
}))

const FullscreenOverlayButton = ({ className }) => {
  const classes = useStyles()
  const history = useHistory()
  const photo = useSelectedPhoto()

  const handleFullscreenClick = (e) => {
    e.stopPropagation() // Prevent triggering the parent click event
    if (photo) {
      history.push(`/camera/${photo.cameraId}/photo/${photo.id}`)
    }
  }

  return (
    <IconButton
      className={`${classes.fullscreenOverlay} ${className || ''}`}
      onClick={handleFullscreenClick}
      aria-label="Enter fullscreen"
      size="medium"
      data-testid="fullscreen-overlay-button"
    >
      <Fullscreen />
    </IconButton>
  )
}

export default FullscreenOverlayButton
